var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSendFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.971,
    height: 16.971,
    viewBox: "0 0 16.971 16.971",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "send-alt-filled",
    d: "M16.378,4.644a.5.5,0,0,0-.526-.115l-11.013,4a.5.5,0,0,0,0,.935l4.3,1.715L12.313,8l.706.7L9.831,11.888l1.722,4.295a.494.494,0,0,0,.926-.015l4-11A.5.5,0,0,0,16.378,4.644Z",
    transform: "translate(8.472 -6.374) rotate(45)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSendFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send_filled.908965c5694c9f392708adeb1dacb481.svg";